export const MotivoCese = Object.freeze({
    renuncia: "Renuncia",
    termino_contrato: "Terminó contrato",
    despido_abandono_trabajo: "Despido por abandono de trabajo",
    despido_falta_grave: "Despido por falta grave",
    no_inicio_relacion_laboral: "No inició relación laboral",
    periodo_prueba: "Periodo de prueba",
    despido_o_destitucion: "Despido o destitución",
    mutuo_disenso: "Mutuo Disenso",
    fallecimiento: "Fallecimiento",
    termino_proyecto:"Terminó de proyecto"
})